import {UserDto} from '@domain/pom'
import {ApiClient, User} from '@hconnect/apiclient'
import {sortBy} from 'lodash'

import {RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

export type GetPomUsersRequestData = {
  namePattern: string
  plantId: string
}

const getPomUsersImpl: RequestFunc<GetPomUsersRequestData, UserDto[]> = async ({
  namePattern,
  plantId
}) => {
  const {data} = await ApiClient.axiosInstance.get<UserDto[]>(
    `/pom-questionnaires/${plantId}/pom-user-suggestions`,
    {
      params: {
        namePattern
      }
    }
  )
  return sortBy(
    data.map(({userId, name}) => ({
      userId,
      name: name ?? ''
    })),
    ['name']
  )
}

export const getPomUsers = loggingDecorator(getPomUsersImpl)

const getUserImpl: RequestFunc<{id: string}, UserDto | undefined> = async ({id}) => {
  const {data} = await ApiClient.axiosInstance.get<User>(`/users/${id}`)
  return data
    ? {
        userId: data.id,
        name: data.name ?? ''
      }
    : undefined
}

export const getUser = loggingDecorator(getUserImpl)
